import { useState, useEffect } from 'react';

// false through the server render and through the first client render, so the two agree
export default function useHydrated() {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => setHydrated(true), []);

  return hydrated;
}
